// Referral system configuration and constants

export const REFERRAL_CONFIG = {
  // Default invite expiry days
  DEFAULT_INVITE_EXPIRY_DAYS: 30,
  
  // Maximum invite expiry days
  MAX_INVITE_EXPIRY_DAYS: 365,
  
  // Minimum invite expiry days
  MIN_INVITE_EXPIRY_DAYS: 1,
  
  // Referral cookie name
  REFERRAL_COOKIE_NAME: 'ref_code',
  
  // Referral cookie expiry (30 days in seconds)
  REFERRAL_COOKIE_EXPIRY: 30 * 24 * 60 * 60,
  
  // Visit deduplication window (30 minutes in milliseconds)
  VISIT_DEDUPE_WINDOW: 30 * 60 * 1000,
  
  // Default currency
  DEFAULT_CURRENCY: 'AUD',
  
  // Maximum discount percentage
  MAX_DISCOUNT_PERCENTAGE: 100,
  
  // Maximum discount amount
  MAX_DISCOUNT_AMOUNT: 1000,
  
  // Minimum discount amount
  MIN_DISCOUNT_AMOUNT: 0.01,
};

export const CODE_TYPES = {
  REFERRAL: 'REFERRAL',
  DISCOUNT: 'DISCOUNT',
};



export const DISCOUNT_TYPES = {
  PERCENT: 'PERCENT',
  FIXED: 'FIXED',
};








  




export const VALIDATION_RULES = {
  CODE: {
    code: {
      required: 'Code is required',
      minLength: { value: 3, message: 'Code must be at least 3 characters' },
      maxLength: { value: 40, message: 'Code must be less than 40 characters' },
      pattern: { value: /^[A-Za-z0-9-_]+$/, message: 'Code can only contain letters, numbers, hyphens, and underscores' },
    },
    discount_amount: {
      min: { value: 0.01, message: 'Discount amount must be greater than 0' },
      max: { value: 1000, message: 'Discount amount cannot exceed 1000' },
    },
  },
  
  INVITE: {
    email: {
      pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Please enter a valid email address' },
    },
    expires_in_days: {
      min: { value: 1, message: 'Expiry must be at least 1 day' },
      max: { value: 365, message: 'Expiry cannot exceed 365 days' },
    },
  },
};

export const MESSAGES = {
  SUCCESS: {
    CODE_CREATED: 'Code created successfully',
    CODE_UPDATED: 'Code updated successfully',
    CODE_DELETED: 'Code deleted successfully',
    INVITE_CREATED: 'Invite created successfully',
    COPIED_TO_CLIPBOARD: 'Copied to clipboard',
  },
  
  ERROR: {
    CODE_CREATE_FAILED: 'Failed to create code',
    CODE_UPDATE_FAILED: 'Failed to update code',
    CODE_DELETE_FAILED: 'Failed to delete code',
    INVITE_CREATE_FAILED: 'Failed to create invite',

  },
  
  INFO: {
    NO_CODES: 'No promo codes found. Create your first code to get started!',
    NO_INVITES: 'No invites found',
    NO_DATA: 'No data available',
  },
};





export const FILTER_OPTIONS = {
  CODE_TYPE: Object.values(CODE_TYPES),
  DISCOUNT_TYPE: Object.values(DISCOUNT_TYPES),
  STATUS: ['active', 'inactive', 'expired', 'pending'],
  DATE_RANGES: [
    { label: 'Last 7 days', value: 7 },
    { label: 'Last 30 days', value: 30 },
    { label: 'Last 90 days', value: 90 },
    { label: 'Last 6 months', value: 180 },
    { label: 'Last year', value: 365 },
  ],
};
